import { createTableFiltersStore } from "./createTableFiltersStore";

export const PRODUCT_LINE_STATUS_OPTIONS: {
  value: "Active" | "Inactive" | "All";
  label: string;
}[] = [
  { value: "All", label: "All Statuses" },
  { value: "Active", label: "Active" },
  { value: "Inactive", label: "Inactive" },
];

export interface ProductLineListFilters extends Record<string, unknown> {
  /** Free-text term matched against the product line name and slug. */
  search: string;
  status: "Active" | "Inactive" | "All";
}

const defaults: ProductLineListFilters = {
  search: "",
  status: "All",
};

/**
 * Filter and paging state for the admin product line list, cached in sessionStorage.
 *
 * No `defaultSort`: the screen has no sort headers, so the page sends no ordering and the backend's
 * own catalog order applies.
 *
 * Bump `version` in step with any change to the shape above or to the status options.
 */
export const useProductLineFiltersStore = createTableFiltersStore<ProductLineListFilters>({
  name: "admin.productLines.filters",
  version: 1,
  defaults,
  sanitize: (filters) => ({
    ...filters,
    // sessionStorage outlives a release: a status no longer offered must not survive as a filter
    // the operator cannot see in the UI, and so cannot clear from it.
    status: PRODUCT_LINE_STATUS_OPTIONS.some((option) => option.value === filters.status)
      ? filters.status
      : defaults.status,
  }),
});
